import { useCallback } from "react";
import { api } from "src/assets/static/ApiRoutes";
import useAsync from "src/hooks/useAsync";
import axiosInstance from "src/utils/axios";

interface UnDeleteAttachmentsRequest{
    attachmentIds : number[];
    companyId: number;
}

const useUndeleteAttachmentsApi = () => {
    const call = useCallback(async (body?: UnDeleteAttachmentsRequest) => {
        try {
          const res = await axiosInstance.post(api.unDeleteAttachments(), body);
          return res.data;
        } catch (error) {
          throw new Error(error);
        }
      }, []);
    
      const { isLoading, execute } = useAsync(call, false);
    
      return {
        unDeleteAttachment: execute,
        isUndeleteAttachmentLoading: isLoading,
      };
}

export default useUndeleteAttachmentsApi